import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3bca707f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3bca707f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bca707f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bca707f')) {
      api.createRecord('3bca707f', component.options)
    } else {
      api.reload('3bca707f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3bca707f&scoped=true", function () {
      api.rerender('3bca707f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Generator/components/supplierbutt/index.vue"
export default component.exports